import { Locale } from 'vant';
import enUS from 'vant/es/locale/lang/en-US';
export default {
  setup() {
    Locale.use('en-US', enUS);
    return {};
  }
};